import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '../../../../../../components/NPS/components/Rating/components/RatingItem/components/Container.js';
import { Label } from '../../../../../../components/NPS/components/Rating/components/RatingItem/components/Label.js';
import { Radio } from '../../../../../../components/NPS/components/Rating/components/RatingItem/components/Radio.js';
import { qaId } from '../../../../../../utils/index.js';
import { NPS_FEEDBACK_QA_ID } from '../../../../../../utils/qaId.js';
export const RatingItem = ({
  checked,
  onChange,
  value,
  label,
  id
}) => {
  return _jsxs(Container, {
    "data-testid": `${qaId(NPS_FEEDBACK_QA_ID)}${label}${checked ? 'Active' : 'Inactive'}`,
    children: [_jsx(Radio, {
      id: id,
      name: "rating",
      value: value,
      onChange: onChange,
      checked: checked
    }), _jsx(Label, {
      htmlFor: id,
      children: label
    })]
  });
};